import script from "./ProductItemSkeletor.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductItemSkeletor.vue?vue&type=script&setup=true&lang=js"

import "./ProductItemSkeletor.vue?vue&type=style&index=0&id=fb762c0c&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb762c0c"]])

export default __exports__